import {LiveEventType} from './live-event.js';

function required(value,label){
  const text=String(value||'').trim();
  if(!text)throw new TypeError(label+' is required');
  return text;
}

export function createLiveQuickActions({eventStore,sessionId}={}){
  if(!eventStore?.append)throw new TypeError('eventStore is required');
  const session=required(sessionId,'sessionId');

  const append=(eventType,input={})=>eventStore.append(session,{...input,eventType});

  return Object.freeze({
    woodAdded:input=>append(LiveEventType.WOOD_ADDED,input),
    chamberOpened:input=>append(LiveEventType.CHAMBER_OPENED,input),
    stageChanged:input=>append(LiveEventType.STAGE_CHANGED,input),
    productChecked:input=>append(LiveEventType.PRODUCT_CHECKED,input),
    custom:input=>append(LiveEventType.CUSTOM,input)
  });
}
